/* global __webpack_public_path__ */ // ✅ Tell ESLint it's a global

import React from "react"

import Layout from "./src/Layout/Layout"
import "./src/Digiflow/scss/main.scss"
import Scripts from "./src/Layout/Scripts"
import { CwvProvider, LocaleContext } from "./src/context/context"

// ✅ Move this below imports
export const onClientEntry = () => {
  const path = window.location.pathname

  // If visiting under /in/en/ or /jp/ja/, make Webpack load chunks from root "/"
  if (
    path.startsWith("/in/en/") ||
    path.startsWith("/jp/ja/") ||
    path.startsWith("/mena/ar/")||
    path.startsWith("/mena/en/")||
    path.startsWith("/uk/en/")
  ) {
    __webpack_public_path__ = "/"
  }
}

// export const wrapPageElement = ({
//   element,
//   props: {
//     pageContext: { site, node_locale, multiLang },
//   },
// }) => {
//   return (
//     <LocaleContext.Provider value={{ locale: node_locale, multiLang }}>
//       <>
//         <Scripts />
//         <CwvProvider>
//           <Layout>{element}</Layout>
//         </CwvProvider>
//       </>
//     </LocaleContext.Provider>
//   )
// }

export const wrapPageElement = ({ element, props }) => {
  const { site, node_locale, multiLang, isLandingPage } =
    props.pageContext || {}

  return (
    <LocaleContext.Provider value={{ locale: node_locale, multiLang }}>
      <>
        <Scripts isLandingPage={isLandingPage} />
        <CwvProvider>
          <Layout isLandingPage={isLandingPage}>{element}</Layout>
        </CwvProvider>
      </>
    </LocaleContext.Provider>
  )
}

